import { Appointments } from '@devexpress/dx-react-scheduler-material-ui';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import { Grid, Typography } from '@mui/material';
import React from 'react';



const AppointmentCell = ({ children,...Props }) => {
 
  const { patient_info_first_name, patient_info_last_name, patient_info_second_name,style,patient_info_age,patient_info_gender } =Props.data;
  
  const cellStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    maxHeight:'5rem',
     marginLeft:'0' 
  };

  
  const personColor =   !Boolean(patient_info_gender) ?  '#FF69B4' : '#279BFF';
  return (
    <Appointments.Appointment
     
      {...Props }
   
    className="appointment-cell"
    style={{
        ...style,
        backgroundColor: 'transparent',
        color: '#343434',
        fontSize: '.8rem',
        minHeight:'5rem',
        maxHeight:'5rem',
      }}
      
    >
      <Grid  container spacing={1} justifyContent={'center'} style={{height:'100%'}}>
        <Grid xs={12} item style={cellStyle}>
          <PersonOutlinedIcon  style={{ color: personColor }} />
          <Typography variant="caption">
          {`${patient_info_first_name !== null ? patient_info_first_name : ''} 
          ${patient_info_second_name !== null ? patient_info_second_name : ''} 
          ${patient_info_last_name !== null ? patient_info_last_name : ''}`}
          </Typography>
          {patient_info_age && <small>({patient_info_age})</small>}
        </Grid>
      </Grid>
    </Appointments.Appointment>
  );
};

export default AppointmentCell;
